// extracted by mini-css-extract-plugin
module.exports = {"heading":"banner-heading-module--heading--fLAAU"};